import type { UserInputValidationError } from '@tectonics/prs/validation';
import type { z } from 'zod';

export const toUserInputValidationError = (issue: z.core.$ZodIssue): UserInputValidationError => ({
  id: issue.message,
});
